import { render, staticRenderFns } from "./index.vue?vue&type=template&id=094fcd42&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094fcd42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094fcd42')) {
      api.createRecord('094fcd42', component.options)
    } else {
      api.reload('094fcd42', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=094fcd42&scoped=true&", function () {
      api.rerender('094fcd42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/productTask/index.vue"
export default component.exports